import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { entriesToString } from '../../utils';
import { omit } from 'lodash';
import { getNoIndex } from '../../pages/SearchResults/utils/meta';
import { getNoIndex as getNoIndexEngines } from '../../pages/SearchResults/Engines/utils/meta';
import { getCurrentBoats as bts } from '../../utils/language';

const IGNORE_PROPS = ['nofollow'];

export default class Link extends PureComponent {
  render() {
    const { to, href } = this.props;
    const path = to || href;

    switch (bts().getPageTypeFromPath(path)) {
    case bts().PAGE_TYPES.brandedSearch:
      return this.renderLink({
        nofollow: getNoIndex(path, true)
      });
    case bts().PAGE_TYPES.enginesBrandedSearch:
      return this.renderLink({
        nofollow: getNoIndexEngines(path, true)
      });
    case bts().PAGE_TYPES.boats:
      return this.renderLink({
        nofollow: getNoIndex(path)
      });
    case bts().PAGE_TYPES.engines:
      return this.renderLink({
        nofollow: getNoIndexEngines(path)
      });
    default:
      return this.renderLink(this.props);
    }
  }
  renderLink = ({ nofollow }) => {
    const { to, title } = this.props;
    if (to) {
      return <RouterLink
        rel={entriesToString({ nofollow: nofollow })} {...omit(this.props, IGNORE_PROPS)}>
        {this.props.children}
      </RouterLink>;
    }
    return <a title={title} rel={entriesToString({ nofollow: nofollow })} {...omit(this.props, IGNORE_PROPS)}>
      {this.props.children}
    </a>;
  }
}

Link.propTypes = {
  children: PropTypes.node,
  nofollow: PropTypes.bool,
  to: PropTypes.string,
  href: PropTypes.string,
  title: PropTypes.string,
};
